module.exports = __webpack_public_path__ + "static/media/DashedBorder.ea27a836.svg";